import * as React from "react";
const SvgChevronUpSmallIcon = (props) => /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m16 14-4-4-4 4", stroke: "#4A4A4A", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgChevronUpSmallIcon;
